import React from "react";
import classNames from "classnames";

import BaseItem from "../body/BaseItem";

const Column = ({ items = [], column, id, mobile, checkContrast }) => {
  if (!items || items.length === 0) return null;

  const itemClass = (show) => classNames({
    'hide-for-desktop': 'mobile' === show,
    'hide-for-small': 'desktop' === show
  });

  return items.map((item, i) => (
    <div className={itemClass(item.show)} key={i}>
      <BaseItem key={item.id} preview mobile={mobile} {...item} checkContrast={checkContrast}/>
    </div>
  ));
};

export default Column;
